<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2022-03-01 10:53:21
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Holiday\HolidayType\newHolidayType.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-01 14:34:45
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_holidayType_form_newTitle')"
    widthClass="max-1000"
    pad="0"
    :initData="HolidayTypeData"
    @change="(changed) => (isChanged = changed)"
    :checkData="['holiday_type_name', 'holiday_type_code', 'remarks']"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Stepper :curStep="curStep" :items="stepper">
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <inputTextFiledMultiLang
                  maxlength="100"
                  :bindData="HolidayTypeData.holiday_type_name"
                  @change="
                    (valueArr) => {
                      HolidayTypeData.holiday_type_name = valueArr;
                    }
                  "
                  :label="
                    $t('label_essweb_holidayType_list_HolidayTypeNameLabel')
                  "
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <normalInputTextFiled
                  :label="
                    $t('label_essweb_holidayType_list_HolidayTypeCodeLabel')
                  "
                  maxlength="100"
                  :rules="
                    $GetRules(['_Require_Rules', '_Length_Rules'], [null, 100])
                  "
                  v-model="HolidayTypeData.holiday_type_code"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="text--secondary">{{
                  $t("label_essweb_holidayType_list_HolidayTypeRemarksLabel")
                }}</v-sheet>
                <v-textarea
                  rows="5"
                  no-resize
                  maxlength="500"
                  filled
                  single-line
                  dense
                  counter="500"
                  v-model="HolidayTypeData.remarks"
                  name="input-7-4"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <v-card :elevation="0" class="pa-0">
            <v-card-text class="pa-0">
              <Tabler
                :headers="headers"
                :showNoContent="false"
                :items="desserts"
              >
                <template v-slot:item.holiday_name="{ item }">
                  {{ $getCommonLangValue(item.holiday_name) }}
                </template>
                <template v-slot:item.holiday_utc_date="{ item }">
                  {{ $getDateTime(item.holiday_utc_date, "YYYY/MM/DD") }}
                </template>
                <template v-slot:item.holiday_time_zone="{ item }">
                  {{ $getUtcByCode(item.holiday_time_zone) }}
                </template>
              </Tabler>
            </v-card-text>
            <v-card-actions class="pb-0 pl-0">
              <v-btn
                text
                color="primary"
                small
                class="text-capitalize mb-3"
                @click="toNewMapping"
              >
                {{ $t("label_essweb_holidayType_form_editHolidayBtnLabel") }}
                <span class="material-icons-round">add</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </Stepper>
    </template>

    <template v-slot:page-actions>
      <CardActions
        :newBtn="stepper.length == curStep && curStep != 0 ? true : false"
        :step="stepper.length == curStep ? false : true"
        @next="toNext"
        :preStep="curStep > 1 ? true : false"
        @pre="curStep = curStep - 1"
        @new="toNew"
        @cancel="$toBack(isChanged)"
      />
    </template>
    <template v-slot:tools-main>
      <mapToPublicHoliday
        :show="mapToDiag"
        :PorpertyData="curPorperty"
        @editPorperty="onEditProperty"
        @close="mapToDiag = false"
      />
    </template>
  </ContentLayout>
</template>
<script>
import mapToPublicHoliday from "@/Page/EssAdmin/Holiday/HolidayType/components/mapToPublicHoliday";
import { mapGetters } from "vuex";
export default {
  name: "newHolidayType",
  components: { mapToPublicHoliday },
  computed: {
    ...mapGetters(["companyLang"]),
  },
  data() {
    return {
      HolidayTypeData: {
        holiday_type_name: "",
        holiday_type_code: "",
        remarks: "",
      },
      curPorperty: null,
      mapToDiag: false,
      stepper: [
        "label_essweb_holidayType_form_step_generalLabel",
        "label_essweb_holidayType_form_step_holidayListLabel",
      ],
      isChanged: false,
      curStep: 1,
      publicUuids: [],
      desserts: [],
      headers: [
        {
          text: "label_essweb_holidayGroup_form_holidayNameLabel",
          value: "holiday_name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_holidayGroup_form_holidayDateLabel",
          value: "holiday_utc_date",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_holidayGroup_form_holidayZoneLabel",
          value: "holiday_time_zone",
          align: "start",
          sortable: false,
        },
      ],
    };
  },
  watch: {
    desserts(val) {
      const that = this;
      that.publicUuids = [];
      this.curPorperty = val;
      val.forEach(function (item) {
        that.publicUuids.push(item.uuid);
      });
    },
  },
  mounted() {},
  methods: {
    toNext: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.curStep = this.curStep + 1;
    },
    toNew() {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_holi_holiday_type",
        url: "/holiday-type/add-table/",
        data: {
          holiday_type_name: this.$transCommonLangKey(
            this.HolidayTypeData.holiday_type_name
          ),
          holiday_type_code: this.HolidayTypeData.holiday_type_code,
          remarks: this.HolidayTypeData.remarks,
          latest_ids: that.publicUuids.join(","),
        },
      }).then((res) => {
        that.$toBack();
      });
    },
    toNewMapping: function () {
      const that = this;
      this.curPorperty = [];
      this.$Sleep(300).then(() => {
        that.curPorperty = that.desserts;
      });
      this.mapToDiag = true;
    },
    onEditProperty: function (obj) {
      this.mapToDiag = false;
      this.desserts = obj;
    },
  },
};
</script>